export interface ProjectAdminScopeOption {
  ecosystemId: string;
  projectId: string;
  label: string;
}

export interface ProjectAdminScopePickerProps {
  options: ProjectAdminScopeOption[];
  selectedKey: string;
  onSelect: (key: string) => void;
}

export default function ProjectAdminScopePicker({
  options,
  selectedKey,
  onSelect,
}: ProjectAdminScopePickerProps) {
  if (options.length === 0) {
    return <p className="tree-dashboard-muted">No projects you can administer.</p>;
  }

  return (
    <div className="admin-member-form" style={{ marginBottom: '1rem' }}>
      <label className="ecosystem-description" htmlFor="project-admin-scope">
        Project in focus
      </label>
      <select
        id="project-admin-scope"
        value={selectedKey}
        onChange={(e) => onSelect(e.target.value)}
      >
        {options.map((opt) => {
          const key = `${opt.ecosystemId}::${opt.projectId}`;
          return (
            <option key={key} value={key}>
              {opt.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
